var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { ButtonAFY, InputAFY, LoadingAFY, ModalComponentAFY, sizes, typeLoaders, variants, variantsTextField, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../../assets/themes/theme";
import { useActivatePolicy } from "../hook/useActivatePolicy";
export var ModalActivePolicy = function (props) {
    var _a = useActivatePolicy({
        policyId: props.policyId,
        quoteId: props.quoteId,
        callQuoteOne: props.callQuoteOne,
        setSeeToast: props.setSeeToast,
        t: props.t,
        onActivate: props.onActivate,
        permissionName: props.permissionName,
    }), email = _a.email, setEmail = _a.setEmail, password = _a.password, setPassword = _a.setPassword, overallLoading = _a.overallLoading, activatePolicy = _a.activatePolicy, getLoadingText = _a.getLoadingText;
    var handleCancel = function () {
        setEmail("");
        setPassword("");
        props.setOpenActivePolicy(false);
    };
    var handleActivate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, activatePolicy()];
                case 1:
                    success = _a.sent();
                    if (success) {
                        props.setOpenActivePolicy(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsx(LoadingAFY, { loading: overallLoading, backgroundColor: themeCore.colors.backgroundLoader, typeAnimation: typeLoaders.LogoAfy, sizeAnimation: 65, textLoading: getLoadingText(), textLoadingColor: themeCore.colors.third, spinnerColor: themeCore.colors.third }), _jsx(ModalComponentAFY, __assign({ openModal: props.openActivePolicy, backgroundColor: "#ffffff", onClose: handleCancel, modalWidth: 500, modalHeight: "auto", padding: 30, border: 0 }, { children: _jsxs("div", __assign({ style: {
                        display: "flex",
                        flexDirection: "column",
                        gap: "24px",
                    } }, { children: [_jsx("h2", __assign({ style: {
                                margin: 0,
                                fontSize: "24px",
                                fontWeight: 600,
                                color: "#1a1a1a",
                                textAlign: "center",
                            } }, { children: "Ingrese sus credenciales para activar la p\u00F3liza" })), _jsx(InputAFY, { label: "Correo electrónico", type: "email", value: email, onChange: function (e) { return setEmail(e.target.value); }, placeholder: "user@correo.com", required: true, variant: variantsTextField.outlined, disabled: overallLoading }), _jsx(InputAFY, { label: "Contraseña", type: "password", value: password, onChange: function (e) { return setPassword(e.target.value); }, placeholder: "Ingrese su contraseña", required: true, variant: variantsTextField.outlined, disabled: overallLoading }), _jsxs("div", __assign({ style: {
                                display: "flex",
                                gap: "16px",
                                justifyContent: "flex-end",
                                marginTop: "8px",
                            } }, { children: [_jsx(ButtonAFY, { label: "Cancelar", variant: variants.outlined, size: sizes.medium, onClick: handleCancel, disabled: overallLoading }), _jsx(ButtonAFY, { label: overallLoading ? "Procesando..." : "Activar", variant: variants.contained, size: sizes.medium, onClick: handleActivate, disabled: !email || !password || overallLoading })] }))] })) }))] }));
};
